/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * @param {HTMLStyleElement} element
 */
module.exports = function (element) {
  const head = document.head;
  const reference = head.querySelector('title').nextSibling;

  head.insertBefore(element, reference);
};
